import React from "react";
import Layout from "../../components/layout";
import { SectionHeader, SectionTitle } from "../../components";

const siteMetadata = {
  title: "Designing Multi-Agent Systems",
  description: "Access your book downloads, manage your account, and explore exclusive content for Designing Multi-Agent Systems",
  author: "Victor Dibia",
  image: "/images/og-service.png",
  keywords: "multi-agent, customer platform, dashboard, payments",
  twitterUsername: "@designingwithml"
};

const PrivacyPage: React.FC = () => {
  return (
    <Layout
      meta={siteMetadata}
      title="Privacy Policy"
      link={"/privacy"}
    >
      <main className="">
        <div className="mb-6"></div>
        <div className=" z-8    rounded">
          <SectionTitle title="Privacy Policy"> </SectionTitle>
          <div className=" text-grpay-500  text-base">
            Your privacy is important to us. It is multiagentbook.com's policy
            to respect your privacy regarding any information we may collect
            from you across our website, http://multiagentbook.com, and other
            sites we own and operate. We only ask for personal information when
            we truly need it to provide a service to you. We collect it by fair
            and lawful means, with your knowledge and consent. We also let you
            know why we’re collecting it and how it will be used. We only retain
            collected information for as long as necessary to provide you with
            your requested service. What data we store, we’ll protect within
            commercially acceptable means to prevent loss and theft, as well as
            unauthorized access, disclosure, copying, use or modification. We
            don’t share any personally identifying information publicly or with
            third-parties, except when required to by law. Our website may link
            to external sites that are not operated by us. Please be aware that
            we have no control over the content and practices of these sites,
            and cannot accept responsibility or liability for their respective
            privacy policies. You are free to refuse our request for your
            personal information, with the understanding that we may be unable
            to provide you with some of your desired services. Your continued
            use of our website will be regarded as acceptance of our practices
            around privacy and personal information. If you have any questions
            about how we handle user data and personal information, feel free to
            contact us. This policy is effective as of 22 December 2022.
          </div>
          <SectionHeader title="Terms of Service"> </SectionHeader>
          <br />
          By accessing the website at http://multiagentbook.com, you are
          agreeing to be bound by these terms of service, all applicable laws
          and regulations, and agree that you are responsible for compliance
          with any applicable local laws. If you do not agree with any of these
          terms, you are prohibited from using or accessing this site. The
          materials contained in this website are protected by applicable
          copyright and trademark law.
          <SectionHeader title="Use License"> </SectionHeader>
          Use License Permission is granted to temporarily download one copy of
          the materials (information or software) on multiagentbook.com's
          website for personal, non-commercial transitory viewing only. This is
          the grant of a license, not a transfer of title, and under this
          license you may not: modify or copy the materials; use the materials
          for any commercial purpose, or for any public display (commercial or
          non-commercial); attempt to decompile or reverse engineer any software
          contained on multiagentbook.com's website; remove any copyright or
          other proprietary notations from the materials; or transfer the
          materials to another person or "mirror" the materials on any other
          server. This license shall automatically terminate if you violate any
          of these restrictions and may be terminated by multiagentbook.com at
          any time. Upon terminating your viewing of these materials or upon the
          termination of this license, you must destroy any downloaded materials
          in your possession whether in electronic or printed format.
          <SectionHeader title="Disclaimer"> </SectionHeader>
          Disclaimer The materials on multiagentbook.com's website are provided
          on an 'as is' basis. multiagentbook.com makes no warranties, expressed
          or implied, and hereby disclaims and negates all other warranties
          including, without limitation, implied warranties or conditions of
          merchantability, fitness for a particular purpose, or non-infringement
          of intellectual property or other violation of rights. Further,
          multiagentbook.com does not warrant or make any representations
          concerning the accuracy, likely results, or reliability of the use of
          the materials on its website or otherwise relating to such materials
          or on any sites linked to this site.
          <br />
          <SectionHeader title="Limitations"> </SectionHeader>
          In no event shall multiagentbook.com or its suppliers be liable for
          any damages (including, without limitation, damages for loss of data
          or profit, or due to business interruption) arising out of the use or
          inability to use the materials on multiagentbook.com's website, even
          if a multiagentbook.com authorized representative has been notified
          orally or in writing of the possibility of such damage. Because some
          jurisdictions do not allow limitations on implied warranties, or
          limitations of liability for consequential or incidental damages,
          these limitations may not apply to you.
          <br />
          <SectionHeader title="Accuracy of materials"> </SectionHeader>
          The materials appearing on multiagentbook.com's website could include
          technical, typographical, or photographic errors. multiagentbook.com
          does not warrant that any of the materials on its website are
          accurate, complete or current. multiagentbook.com may make changes to
          the materials contained on its website at any time without notice.
          However multiagentbook.com does not make any commitment to update the
          materials.
          <br />
          <SectionHeader title="Links"> </SectionHeader>
          multiagentbook.com has not reviewed all of the sites linked to its
          website and is not responsible for the contents of any such linked
          site. The inclusion of any link does not imply endorsement by
          multiagentbook.com of the site. Use of any such linked website is at
          the user's own risk.
          <br />
          <SectionHeader title="Modifications"> </SectionHeader>
          multiagentbook.com may revise these terms of service for its website
          at any time without notice. By using this website you are agreeing to
          be bound by the then current version of these terms of service.
          <br />
          <SectionHeader title="Governing Law"> </SectionHeader>
          These terms and conditions are governed by and construed in accordance
          with the laws of California and you irrevocably submit to the
          exclusive jurisdiction of the courts in that State or location.
        </div>
      </main>
    </Layout>
  );
};

export default PrivacyPage;

